import { z } from 'zod';

import { birthDateSchema } from './BirthDate.schema';

export const petNameRequiredMsg = 'Pet name is required';
export const speciesRequiredMsg = 'Pet type is required';
export const breedRequiredMsg = 'Breed is required';
export const genderRequiredMsg = 'Gender is required';
export const weightRequiredMsg = 'Weight (lbs) is required';
export const weightNotNegativeMsg = 'Weight must be greater than 0';
export const petNameMaxLengthMsg = 'Pet name cannot exceed 50 characters';

export const petBaseFormSchema = z.object({
    petName: z.string({ message: petNameRequiredMsg }).trim().min(1, petNameRequiredMsg).max(50, petNameMaxLengthMsg),
    speciesId: z.number({ message: speciesRequiredMsg }),
    isAdopted: z.preprocess(val => val ?? false, z.boolean()),
    birthDate: birthDateSchema,
    gotchaDay: z.string().optional(),
    colorId: z.number().optional(),
    medications: z.string().trim().max(200).optional(),
    healthConditions: z.string().trim().max(200).optional(),
    medicalAllergies: z.string().trim().max(200).optional(),
});

export const petBaseFormSchemaVetRx = petBaseFormSchema.extend({
    breedId: z.number({
        error: issue => (issue.input === undefined ? breedRequiredMsg : undefined),
    }),
    genderId: z.number({
        error: issue => (issue.input === undefined ? genderRequiredMsg : undefined),
    }),
    weight: z
        .number({
            error: () => weightRequiredMsg,
        })
        .refine(val => Number(val) > 0, {
            message: weightNotNegativeMsg,
        }),
});

export const bigPetFormSchema = petBaseFormSchema.extend({
    breedId: z.number({
        error: issue => (issue.input === undefined ? breedRequiredMsg : undefined),
    }),
    genderId: z.number({
        error: issue => (issue.input === undefined ? genderRequiredMsg : undefined),
    }),
    isMixedBreed: z.preprocess(val => val ?? false, z.boolean()),
    isSpayedNeutered: z.preprocess(val => val ?? false, z.boolean()),
    isPetPregnant: z.preprocess(val => val ?? false, z.boolean()),
    weight: z
        .number({
            error: () => weightRequiredMsg,
        })
        .refine(val => Number(val) > 0, {
            message: weightNotNegativeMsg,
        }),
});
export const smallPetFormSchema = petBaseFormSchema.extend({
    genderId: z.number().optional(),
});
export const smallPetFormSchemaVetRx = petBaseFormSchema.extend({
    genderId: z.number({
        error: issue => (issue.input === undefined ? genderRequiredMsg : undefined),
    }),
});
export type MyPetFormInterface = z.infer<
    typeof petBaseFormSchema & Partial<typeof bigPetFormSchema> & Partial<typeof smallPetFormSchema>
>;

export type DrawerAddedPetInterface = Partial<MyPetFormInterface & { petId: number | string }>;
